var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v(" Validação "),
      _c(
        "v-btn",
        {
          attrs: {
            depressed: "",
            block: "",
            color: "primary",
            loading: _vm.loading,
            disabled: _vm.loading
          },
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "Urna" })
            }
          }
        },
        [_c("v-icon", [_vm._v("ballot")]), _vm._v("Votar ")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }